import { render, staticRenderFns } from "./CancelBatch.vue?vue&type=template&id=874e11a6"
import script from "./CancelBatch.vue?vue&type=script&lang=js"
export * from "./CancelBatch.vue?vue&type=script&lang=js"
import style0 from "./CancelBatch.vue?vue&type=style&index=0&id=874e11a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports